// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"6dc3d68d","94":"6dc3d68d","369":"a878b0d6","676":"6dc3d68d"}[chunkId] + ".css";
};